module.exports = __webpack_public_path__ + "img/Swift 2023.410cdb35.png";